module.exports = __webpack_public_path__ + "static/media/logo.f15ff725.png";